import SDIcon from './SDIcon'

const IconCarbonTaskAddV2 = props => (
  <div style={{ position: 'relative', display: 'inline-flex', width: props.size || 32, height: props.size || 32 }}>
    <SDIcon title='TaskAdd' {...props}>
      <polygon points='31 24 27 24 27 20 25 20 25 24 21 24 21 26 25 26 25 30 27 30 27 26 31 26 31 24' />
      <path d='M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2H17V28H7V7h3v3H22V7h3v9h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z' />
    </SDIcon>
    <span
      style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        fontSize: (props.size || 32) * 0.4,
        fontWeight: 'bold',
        fontFamily: 'Arial, sans-serif',
        lineHeight: 1,
        color: '#161616',
        backgroundColor: '#fff',
        borderRadius: 2,
        padding: '1px 2px',
      }}
    >
      V2
    </span>
  </div>
)

export default IconCarbonTaskAddV2
